var React = require('react');

function Shell (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m832 0h-768c-35.35 0-64 28.65-64 64v640c0 35.35 28.65 64 64 64h768c35.35 0 64-28.65 64-64v-640c0-35.35-28.65-64-64-64zm-704 448 128-128-128-128 64-64 192 192-192 192zm512 64h-256v-64h256z"}));
}

Shell.defaultProps = {"version":"1.1","viewBox":"0 0 896 768"};

module.exports = Shell;

Shell.default = Shell;
